import React from "react";
import {useTheme} from "@mui/material/styles";
import Icon from "@mui/material/Icon";
import Typography from "@mui/material/Typography";
import {ISectionHeaderProps} from "./types";
import Box from "@mui/material/Box";


export const FormSectionHeader: React.FC<ISectionHeaderProps> =  (
    {
        sectionIcon,
        title,
        typeVariant="h6"
    } : ISectionHeaderProps
): JSX.Element => {
    const theme = useTheme();

    return (
        <Box
            display={"flex"}
            alignItems={"end"}
            justifyContent={"start"}
            sx={{mt: .75}}
        >
            {sectionIcon &&
                <Icon
                    sx={{
                        color: theme.daPalette.grey.dark,
                        fontSize: theme.spacing(4),
                        marginRight: theme.spacing(1),
                    }}
                >
                    {sectionIcon}
                </Icon>
            }
            <Typography variant={typeVariant}>{title}</Typography>
        </Box>
    )
}